module.exports = __webpack_public_path__ + "img/voellerei.037d4c0c.png";